var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14",
    id: "Office-Building-1--Streamline-Flex",
    height: 14,
    width: 14,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Office Building 1 Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "office-building-1--office-building-work"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 218",
    stroke: "#e5eaf9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M2.27182 13.2501h-0.17588c-0.50912 0 -0.9379 -0.3818 -0.97498 -0.8896 -0.206703 -2.8306 -0.10791 -7.1808 0.26089 -10.20716 0.08656 -0.71025 0.5824 -1.286398 1.2858 -1.417435C3.34427 0.609858 4.19924 0.5 4.98021 0.5c0.78098 0 1.63595 0.109858 2.31257 0.235905 0.70339 0.131037 1.19819 0.708815 1.27783 1.419865 0.07453 0.66537 0.13752 1.2142 0.19501 2.03173",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 221",
    stroke: "#e5eaf9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3.73706 2.8526h2.48633",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 223",
    stroke: "#e5eaf9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3.73706 4.97943h2.48633",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 224",
    stroke: "#e5eaf9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m0.5 13.2501 4.375 0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Intersect",
    stroke: "#e5eaf9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M13.5 13.5c-0.174 -0.7014 -0.5706 -1.3292 -1.1321 -1.7882 -0.5987 -0.4893 -1.3482 -0.7567 -2.1215 -0.7567 -0.77324 0 -1.52273 0.2674 -2.12145 0.7567 -0.56153 0.459 -0.95805 1.0868 -1.13209 1.7882",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    stroke: "#e5eaf9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M10.2465 9.37503c1.04 0 1.625 -0.585 1.625 -1.625s-0.585 -1.625 -1.625 -1.625c-1.04004 0 -1.62504 0.585 -1.62504 1.625s0.585 1.625 1.62504 1.625Z",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkUsers);
export default __webpack_public_path__ + "static/media/dark-users.ecbf11a626dada0f0d57de86531c5d46.svg";
export { ForwardRef as ReactComponent };